export { ViewerCanvas, ObjectRotationGroup, type ViewerCanvasProps, type ViewerCanvasHandle, type SnapshotCaptureOptions, type SnapshotCaptureResult, type AutoRotateMode, type SceneStats, type SceneAaStats, type ViewerPostFX } from './viewer-canvas';
export { GlbModel, prefetchPbrOverrideTextures, prefetchSceneModelAssetUrls, type GlbModelHandle, type GlbModelProps, type MaterialOverrides, type AnimationControls, type PerMeshOverrides, type PBRMeshOverrideData, type DisplayMode } from './glb-model';
export { AssetModalModelPreview } from './asset-modal-model-preview';
export { EditorCanvas, type EditorCanvasProps, type PostFXSettings } from './editor-canvas';
export { Hotspot, type HotspotData, type HotspotProps } from './hotspot';
export { InstancedGlbGroup, type InstancedGlbGroupProps, type InstanceTransform } from './instanced-glb-group';
export { Config3DPlayerAdapter, type SceneStoreBridge, type SceneViewerBridge } from './player-adapter';
export { ModifiedMesh, type ModifierDef } from './modified-mesh';
export { compileModifierShader, updateModifierUniforms, type GpuModifierDef, type ModifierUniforms } from './modifier-shaders';
export { applyCpuModifiers, rebuildTangentsAfterCpuModifiers, ensureGeometryTangents, type CpuModifierDef } from './modifier-cpu';
export { applyTransmissionAttenuation, sanitizeAttenuationDistance, type TransmissionAttenuationOptions } from './transmission-attenuation';
export { createTextCanvasTexture, type TextCanvasOptions } from './text-canvas-texture';
export {
  configureStableTextureSampling,
  configureNormalMapSampling,
  textureHasStableMinFilter,
} from './texture-sampling';
export {
  setPlayerTextureQuality,
  resetPlayerTextureQuality,
  ensurePlayerTextureQuality,
  applyPlayerTextureQualityPreset,
  getPlayerTextureQualityOptions,
  getTextureQualityCacheSuffix,
  getPlayerTextureQualityEpoch,
  subscribePlayerTextureQuality,
  type PlayerTextureQualityOptions,
  type PlayerTextureQualityPreset,
  type PlayerTextureMaxEdge,
  type PlayerTextureResolutionScale,
  optimizeTextureUrl,
  encodeTextureUrlForFetch,
} from './player-texture-quality';
export {
  evaluateMaterialGraph,
  libraryMaterialSkipsToneMap,
  stampSkipToneMapFromLibraryName,
  disposeMaterialGraphResult,
  materialGraphUsesPerMeshUvRandomize,
  extractUvRandomizeMetaFromMaterial,
  uvRandomizeMetaHasVariance,
  C3D_UV_RANDOMIZE_UD,
  collectMaterialGraphImageUrls,
  warmMaterialGraphTextureCache,
  warmMaterialGraphEvalVariants,
  listMaterialGraphAttributeKeys,
  getPendingMaterialTextureWork,
  getActiveGraphTextureJobs,
  truncateGraphemes,
  resolveTextCanvasFontMapEntry,
  resolveTextAttrMaxCharsFromMaterials,
  resolveEngravingMaxCharsFromMaterials,
  type MaterialGraphData,
  type MaterialGraphEvalContext,
  type EvalResult,
  type AttributeDef,
  type TextCanvasFontMapEntry,
  type C3dUvRandomizeMeta,
} from './material-graph-eval';
export { PrimitiveMaterial, type PrimitiveMaterialProps } from './primitive-material';
export {
  MaterialSphereThumbnail,
  type MaterialSphereThumbnailProps,
  type MaterialSphereThumbnailHandle,
} from './material-sphere-thumbnail';
export { ModelShelfThumbnail, type ModelShelfThumbnailProps } from './model-shelf-thumbnail';
export { loadEnvMap, getCachedEnvMap, getEnvMapLoadState, invalidateEnvMapCache, ENV_PRESET_NAMES, envUrlHasKnownExt } from './env-map-loader';
export type { EnvMapLoadState } from './env-map-loader';
export {
  notifySceneAssetReplaced,
  SCENE_ASSET_REPLACED,
  type SceneAssetReplacedDetail,
} from './asset-url-invalidation';
export { buildEffectiveVisibleMap, type SceneObjectLike } from './scene-visibility';
export { editorHdrProxyUrl, editorHdrFullUrl, resolveEditorHdrUrl } from './hdr-proxy';
export { cameraLinkedEnvYaw, demoteNestedTransmission } from './camera-env-link';
export { NestedTransmissionApplier } from './nested-transmission-applier';
export {
  isTransmissionRenderPass,
  installTransmissionPassTracker,
  updateTransmissionCullState,
} from './transmission-front-cull';
export { collectGroupMaterialReceiverIds, type GroupMaterialSceneObject } from './group-material-receivers';
export {
  armMaterialTransitionClock,
  commitLayoutMaterialTransitionClock,
  materialTransitionBlend,
  isMaterialTransitionClockActive,
  getMaterialTransitionStartedAt,
} from './material-transition-clock';
export {
  getSharedGraphMaterial,
  invalidateSharedGraphMaterial,
  peekSharedGraphMaterial,
} from './shared-graph-material';
export {
  configureGltfLoaders,
  isGltfLoaderSetupReady,
  extendGltfLoader,
  ConfigureGltfLoaders,
} from './gltf-loader-setup';
export { patchCompileAsyncSafe, patchCompileAsyncOnRenderer, compileAsyncSafe } from './compile-async-safe';
// Side-effect: patch WebGLRenderer.compileAsync before any Canvas mounts.
import './compile-async-safe';
export {
  GlobalSplatProvider,
  GsplatObject,
  SplatCutoutObject,
  GSPLAT_FORMATS,
  isSplatAssetFormat,
  isSplatAssetUrl,
  parseSplatBuffer,
  toViewSplatUrl,
  useGlobalSplatManager,
  type GlobalSplatManagerAPI,
  type ParsedSplat,
  type SplatCutoutMode,
  type SplatCutoutObjectProps,
} from './gsplat/global-splat-manager';
